import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, Input, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { BsLockFill } from '@react-icons/all-files/bs/BsLockFill';
import { Form, FormGroup } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { AppStore } from '../Core/AppStore';
import { ManageStore } from './ManageStore';

export interface IPasswordProps {
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class PasswordModal extends React.Component<IPasswordProps> {
    public render() {
        return (
            <Modal title={this.title} modalHandle={this.props.modalHandle} footer={this.footer} bodyClass="p-0">
                <Form className="p-3">
                    <FormGroup color={this.changePasswordForm.fields.oldPassword.state}>
                        <div className="col-xs-2">
                            <label>Password</label>
                        </div>
                        <div className="col-xs-10">
                            <Input
                                type="password"
                                field={this.changePasswordForm.fields.oldPassword}
                                placeholder="Your Current Password"
                                required
                            />
                        </div>
                    </FormGroup>
                    <FormGroup color={this.changePasswordForm.fields.password.state}>
                        <div className="col-xs-2">
                            <label>Password</label>
                        </div>
                        <div className="col-xs-10">
                            <Input
                                type="password"
                                field={this.changePasswordForm.fields.password}
                                placeholder="A New Secure Password"
                                min={7}
                                required
                            />
                        </div>
                    </FormGroup>
                    <FormGroup color={this.changePasswordForm.fields.passwordConfirm.state}>
                        <div className="col-xs-2">
                            <label>Password</label>
                        </div>
                        <div className="col-xs-10">
                            <Input
                                type="password"
                                field={this.changePasswordForm.fields.passwordConfirm}
                                placeholder="Confirm Password"
                                min={7}
                                required
                            />
                        </div>
                    </FormGroup>
                </Form>
            </Modal>
        );
    }

    @computed
    private get footer() {
        return (
            <button className="btn btn-primary" onClick={this.submitAsync} disabled={this.loading}>
                {this.loading ? 'Changing...' : 'Change Password'}
            </button>
        );
    }

    @bind
    @action
    private async submitAsync(event: React.FormEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.changePasswordForm.onSubmit();
        if (this.changePasswordForm.validate()) {
            const task = this.tasksStore.startSessionTask(`Change Password`);

            try {
                await this.manageStore.changePasswordAsync(this.changePasswordForm.values);
                task.complete();

                this.accountStore.signinRedirect({
                    returnUrl: '/preferences',
                });
            } catch (e: any) {
                if (e.modelState) {
                    this.changePasswordForm.clearGlobalErrors();
                    this.changePasswordForm.addErrors(e.modelState);
                }

                task.error(e);
            }
        } else {
            console.log('invalid');
        }
    }

    //Private Fields
    private title = (
        <span className="text-header fw-bold">
            <BsLockFill /> Change Password
        </span>
    );

    @observable
    private loading = false;
    private readonly changePasswordForm = new FormStore<Mri.Web.Portal.Controllers.Manage.ChangePasswordModel>({
        oldPassword: '',
        password: '',
        passwordConfirm: '',
    });
    @inject
    private accountStore!: AccountStore;
    @inject
    private manageStore!: ManageStore;
    @inject
    private tasksStore!: TasksStore;
}
